import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {ToastContainerDirective} from 'ngx-toastr';
import {ToastrMessagesProvider} from '../../../../services/toastr-messages.service';

@Component({
  selector: 'mc-drawer-toastr',
  templateUrl: './drawer-toastr.component.html',
  styleUrls: ['./drawer-toastr.component.scss'],
})
export class DrawerToastrComponent implements AfterViewInit, OnDestroy {
  @ViewChild(ToastContainerDirective, {static: true})
  toastContainer: ToastContainerDirective;

  constructor(private toastrMessagesProvider: ToastrMessagesProvider) {}

  ngAfterViewInit(): void {
    this.toastrMessagesProvider.drawerMessageContainer = this.toastContainer;
  }

  ngOnDestroy() {
    this.toastrMessagesProvider.drawerMessageContainer = null;
    this.toastrMessagesProvider.switchToMainContainer();
  }
}
